import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const betwrightColors: ThemeTailwindType = {
    '--primary': '196 91% 53%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#263745',
    secondary: '#ffce00',
    tertiary: '#1bb9f4',
    dark: '#262c32',
    shade1: '#262c32',
    shade2: '#263745',
    shade3: '#323E4B',
    shade4: '#424d59',
    shade5: '#525c68',
    shade6: '#f5f7f8',
    textDark: '#020203',
    textTertiary: '#1bb9f4',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.tertiary,

        borderColor: colorPalette.tertiary,
        borderColorSecondary: colorPalette.tertiary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.tertiary,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.dark,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#262c32',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#ffce00',
        buttonTxtColor: '#020203',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
